export default __webpack_public_path__ + "static/media/world_map_bg.73a85399.jpg";